import type { ChromeCopy } from './types'

export const or: ChromeCopy = {
  appName: 'ସମଝୋ',
  tagline: 'କାଗଜ ବୁଝନ୍ତୁ। ଏହାପରେ କ’ଣ କରିବେ, ଜାଣନ୍ତୁ।',
  savedTitle: 'ସେଭ୍ କରାଯାଇଥିବା କାଗଜ',
  upcomingTitle: 'ଆସନ୍ତା ଶେଷ ତାରିଖଗୁଡ଼ିକ',
  markDone: 'କାମ ହୋଇଗଲା',
  doneLabel: 'ହୋଇଗଲା',
  deadlineCheckIn: '{n}ଟି ସେଭ୍ କରାଯାଇଥିବା କାଗଜର ଶେଷ ତାରିଖ ପାଖେଇ ଆସିଛି। କାମ ହୋଇଗଲା କି?',
  savedHint: 'ଏଗୁଡ଼ିକ କେବଳ ଏହି ଫୋନରେ ଅଛି। କାଗଜର ଫଟୋ ଓ ପୂରା ଲେଖା କେବେ ସେଭ୍ ହୁଏ ନାହିଁ — କେବଳ ଦରକାରୀ ତଥ୍ୟ।',
  emptySaved: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାଗଜ ସେଭ୍ ହୋଇନାହିଁ।',
  clearAll: 'ସବୁ ଲିଭାନ୍ତୁ',
  deleteItem: 'ଲିଭାନ୍ତୁ',
  aboutTitle: 'ଗୋପନୀୟତା ଓ ଦରକାରୀ ସୂଚନା',
  privacyPoints: [
    'ଆପଣଙ୍କ କାଗଜର ଫଟୋ ଓ ସେଥିରେ ଲେଖାଥିବା କଥା ଏହି ଫୋନରେ ହିଁ ପଢ଼ାଯାଏ ଓ ବୁଝାଯାଏ। ଫଟୋଟି କୌଣସି ଜାଗାକୁ ଅପଲୋଡ୍ ହୁଏ ନାହିଁ।',
    'ଆପଣ "ସେଭ୍ କରନ୍ତୁ" ନ ଦବାଇବା ଯାଏଁ କିଛି ସେଭ୍ ହୁଏ ନାହିଁ। "ନୂଆ କାଗଜ" ଦବାଇଲେ ଆଗର କାଗଜଟି ସ୍କ୍ରିନ୍ ଓ ମେମୋରିରୁ ହଟିଯାଏ।',
    'ସେଭ୍ କଲେ କେବଳ ଦରକାରୀ ତଥ୍ୟ (ତାରିଖ, ଟଙ୍କା ପରିମାଣ, ନମ୍ବର) ରଖାଯାଏ, କେବଳ ଏହି ଫୋନରେ — ଫଟୋ ବା ପୂରା ଲେଖା ନୁହେଁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ଏଗୁଡ଼ିକ ଲିଭାଇ ପାରିବେ।',
    'ଇଣ୍ଟରନେଟ୍ କେବଳ ତିନୋଟି କାମ ପାଇଁ ଲାଗେ: ପ୍ରଥମ ଥର ପଢ଼ିବା ଟୁଲ୍ ଓ ସ୍ୱରଗୁଡ଼ିକ (ସମଝୋର ନିଜ ସାଇଟରୁ) ଡାଉନଲୋଡ୍ କରିବା ପାଇଁ, ଆଉ — କେବଳ ଆପଣ କହିଲେ — କାଗଜର ଇଂରାଜୀ ଧାଡ଼ିଗୁଡ଼ିକ ଅନୁବାଦ କରିବା ପାଇଁ। ଅନୁବାଦ ପାଇଁ ପଠାଯାଇଥିବା ଧାଡ଼ି ସେଭ୍ ହୁଏ ନାହିଁ, ଆଉ ଆଧାର ଓ ଫୋନ ଭଳି ନମ୍ବର ଆଗରୁ ହଟାଇ ଦିଆଯାଏ। ତୃତୀୟରେ — କେବଳ ଆପଣ ପ୍ରଶ୍ନ ପଚାରିଲେ: ଉତ୍ତର ଲେଖିବା ପାଇଁ କାଗଜର ଲେଖା ଓ ଆପଣଙ୍କ ପ୍ରଶ୍ନ ସମଝୋ ସର୍ଭର ଓ ଏକ AI ସେବାକୁ (Groq) ଯାଏ, ଆଧାର, ପାନ୍, ଫୋନ ଓ ଇମେଲ ଆଗରୁ ହଟାଇ; କେବଳ ସରକାରୀ ୱେବସାଇଟ ଦେଖାଯାଏ, ଆଉ କିଛି ସେଭ୍ ହୁଏ ନାହିଁ। ଯେଉଁ ଧାଡ଼ିଗୁଡ଼ିକ ଇଂରାଜୀରେ ନାହିଁ, ସେଗୁଡ଼ିକୁ ଏକ AI ସେବା (Groq) ଅନୁବାଦ କରେ।',
    'ସମଝୋରେ କୌଣସି ବିଜ୍ଞାପନ ନାହିଁ। ଆମେ କେବଳ ଗଣୁ କେତେ ଜଣ ଆପ୍ ଖୋଲନ୍ତି (Cloudflare Web Analytics, କୌଣସି କୁକି ବିନା)। ଆପଣଙ୍କ କାଗଜରୁ କିଛି ବି ସେଥିରେ ଯାଏ ନାହିଁ, ଆଉ କାଗଜର ଲେଖା କେବେ ବି ଲଗ୍ କରାଯାଏ ନାହିଁ।'
  ],
  disclaimerTitle: 'ଏହା ସରକାରୀ ବା ଆଇନଗତ ପରାମର୍ଶ ନୁହେଁ',
  disclaimer: 'ସମଝୋ ଏକ ସ୍ୱାଧୀନ ସାହାଯ୍ୟକାରୀ ଟୁଲ୍, ସରକାରୀ ୱେବସାଇଟ୍ ନୁହେଁ। ଏହା ଆପଣଙ୍କ କାଗଜକୁ ସହଜ କରି ବୁଝାଏ, କିନ୍ତୁ ଏହାର ବ୍ୟାଖ୍ୟା ସରକାରୀ ବା ଆଇନଗତ ବ୍ୟାଖ୍ୟା ନୁହେଁ। ଦରକାରୀ କଥା ସବୁବେଳେ ମୂଳ କାଗଜ ବା କାଗଜ ଦେଇଥିବା ଅଫିସ୍ ସହ ମିଳାଇ ନିଅନ୍ତୁ।',
  contactTitle: 'କିଛି ଅସୁବିଧା ହେଉଛି କି?',
  contact: 'କିଛି ଅସୁବିଧା ହେଲେ ଆମ ସହ ଏଠାରେ ଯୋଗାଯୋଗ କରନ୍ତୁ:',
  freeTitle: 'ସମ୍ପୂର୍ଣ୍ଣ ମାଗଣା',
  free: 'ସମଝୋ ଓପନ୍-ସୋର୍ସ ଟୁଲ୍ ଦ୍ୱାରା ଚାଲେ: ପଢ଼ିବା ପାଇଁ Tesseract, ଆଉ ଶୁଣାଇବା ପାଇଁ ଆପଣଙ୍କ ଫୋନର ନିଜ ସ୍ୱର କିମ୍ବା Metaର ଓପନ୍ MMS ସ୍ୱର (CC BY-NC 4.0)। କୌଣସି ଆକାଉଣ୍ଟ ନାହିଁ, କୌଣସି ଟଙ୍କା ନାହିଁ।',
  shareApp: 'WhatsApp ରେ ସେୟାର୍ କରନ୍ତୁ',
  installApp: 'ଆପ୍ ଫୋନରେ ଯୋଡ଼ନ୍ତୁ',
  offline: 'ଆପଣ ଅଫଲାଇନ୍ ଅଛନ୍ତି',
  offlineHint: 'ଆଗରୁ ସମଝୋ ବ୍ୟବହାର ହୋଇଥିଲେ, ଇଣ୍ଟରନେଟ୍ ବିନା ବି କାଗଜ ପଢ଼ାଯାଇପାରିବ।',
  shareAppMessage: 'ସରକାରୀ କାଗଜ ସହଜ ଭାଷାରେ ବୁଝିବା ଓ ଶୁଣିବା ପାଇଁ SAMJHO ବ୍ୟବହାର କରନ୍ତୁ (ମାଗଣା):\nhttps://samjho.pages.dev'
}
